export default __webpack_public_path__ + "Android.42c105d512a489633b6c9d93a22a8285.mp4";